module.exports = __webpack_public_path__ + "img/khabarovsk@2x.f2047eff.png";